import * as React from "react";
const MetaContext = React.createContext(void 0);
const MetaProvider = ({
  children,
  value
}) => {
  return /* @__PURE__ */ React.createElement(MetaContext.Provider, { value }, children);
};
const useMeta = () => {
  const context = React.useContext(MetaContext);
  if (!context) {
    throw new Error("useMeta must be used within a MetaContext");
  }
  return context;
};
export {
  MetaProvider,
  useMeta
};
//# sourceMappingURL=MetaContext.js.map
